import React, { useState } from "react";
import { Wallet } from "lucide-react";
import { NotaBoard } from "@/components/NotaBoard";
import { InvoiceA4Board } from "@/components/InvoiceA4Board";

const TABS = [
  { key: "nota", label: "Nota (A5)" },
  { key: "invoice", label: "Invoice (A4)" },
  { key: "struk", label: "Struk Payment (58mm)" },
];

export const PaymentBoard = () => {
  const [tab, setTab] = useState("nota");
  return (
    <div className="space-y-5" data-testid="payment-board">
      <div className="glass rounded-2xl p-5 md:p-6 flex flex-wrap items-center gap-4 justify-between">
        <div className="flex items-center gap-3">
          <Wallet className="w-5 h-5 text-blue-400" />
          <div>
            <h3 className="font-display text-xl font-semibold">Papan Pembayaran</h3>
            <p className="text-xs text-slate-400 mt-1">
              Nota, Invoice, dan Struk cetak · pembayaran otomatis masuk Faktur Jual &amp; Laporan Admin
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              data-testid={`payment-tab-${t.key}`}
              onClick={() => setTab(t.key)}
              className={`rounded-xl px-4 py-2 text-[11px] font-semibold uppercase tracking-wider transition-colors duration-200 ${
                tab === t.key
                  ? "bg-blue-600 text-white"
                  : "border border-white/10 bg-slate-900/70 text-slate-300 hover:bg-slate-800"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "nota" && <NotaBoard mode="nota" />}
      {tab === "invoice" && <InvoiceA4Board />}
      {tab === "struk" && <NotaBoard mode="struk" />}
    </div>
  );
};
